import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import DashboardIcon from '@material-ui/icons/Dashboard';
import styled from 'styled-components';
import logoMin from '../img/logo-min.svg';
import sendIcon from '../img/send-icon.svg';
import commandsIcon from '../img/commands-icon.svg';
import receptionMerchandisesIcon from '../img/reception-merchandises-icon.png';
import receiptIcon from '../img/receipt-icon.svg';
import notSentIcon from '../img/not-sent-icon.svg';
import retrunVoucherIcon from '../img/return-voucher-icon.svg';
import exportIcon from '../img/export-icon.svg';
import importIcon from '../img/import-icon.svg';
import operationsIcon from '../img/operations-icon.svg';

import stockIcon from '../img/stock-icon.svg';

import stockIconBlack from '../img/stock-icon-black.svg';
import userLogo from '../img/user.svg';
// import penIcon from '../img/pen-icon.svg';

const ListItemIconCustom = styled(ListItemIcon)`
  padding-top: 18px;
  padding-bottom: 18px;
`;

const Navigation = ({ dispatch, isStockHandled, currentUser, accountType }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElCommands, setAnchorElCommands] = useState(null);
  const [anchorElStocks, setAnchorElStocks] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorElCommands(null);
    setAnchorElStocks(null);
  };

  const openCommandsMenu = event => {
    setAnchorElCommands(event.currentTarget);
  };

  const openStockMenu = event => {
    setAnchorElStocks(event.currentTarget);
  };

  const logout = () => {
    localStorage.removeItem('token');
    dispatch({ type: 'RESET_APP' });
  };
  return (
    <List style={{ overflowY: 'scroll' }} className="scroll-menu">
      <ListItem component={Link} to="/not-sent">
        <ListItemIcon
          style={{
            position: 'relative',
            right: '9px',
            marginBottom: 10
          }}
        >
          <img src={logoMin} width="45" alt="logo sympl" />
        </ListItemIcon>
      </ListItem>
      <div style={{ height: '85vh', paddingBottom: 30 }}>
        <ListItem button component={Link} to="/dashboard">
          <Tooltip title="Dashboard" placement="right">
            <ListItemIconCustom>
              <DashboardIcon style={{ fontSize: 32, color: '#fff' }} />
            </ListItemIconCustom>
          </Tooltip>
        </ListItem>

        <ListItem button onClick={openCommandsMenu}>
          <Tooltip title="Commandes" placement="right">
            <ListItemIconCustom>
              <img
                src={commandsIcon}
                width="35"
                height="50"
                alt="Profile icon"
              />
            </ListItemIconCustom>
          </Tooltip>
        </ListItem>
        <Menu
          id="simple-menu-commands"
          anchorEl={anchorElCommands}
          keepMounted
          open={Boolean(anchorElCommands)}
          onClose={handleClose}
          style={{ marginLeft: 50 }}
        >
          <MenuItem onClick={handleClose} component={Link} to="/not-sent">
            <ListItemIcon style={{ padding: '10px 0px' }}>
              <img src={notSentIcon} width="28" alt="not sent icon" />
            </ListItemIcon>
            <ListItemText primary="Colis prêt" />
          </MenuItem>
          <MenuItem onClick={handleClose} component={Link} to="/sent-by-me">
            <ListItemIcon style={{ padding: '10px 0px' }}>
              <img src={sendIcon} width="25" alt="send icon" />
            </ListItemIcon>
            <ListItemText primary="Expédition" />
          </MenuItem>
          <MenuItem onClick={handleClose} component={Link} to="/sent-to-me">
            <ListItemIcon style={{ padding: '10px 0px' }}>
              <img src={receiptIcon} width="25" alt="reception icon" />
            </ListItemIcon>
            <ListItemText primary="Réception" />
          </MenuItem>
          {/* <MenuItem onClick={handleClose} component={Link} to="/add-command">
            <ListItemIcon style={{ padding: '10px 0px' }}>
              <img src={penIcon} width="32" alt="reception icon" />
            </ListItemIcon>
            <ListItemText primary="Créer une commande" />
          </MenuItem> */}
          <MenuItem
            onClick={handleClose}
            component={Link}
            to="/import-commands"
          >
            <ListItemIcon style={{ padding: '10px 0px' }}>
              <img
                src={importIcon}
                width="32"
                height="50"
                alt="reception icon"
              />
            </ListItemIcon>
            <ListItemText primary="importer des commandes" />
          </MenuItem>
        </Menu>

        {accountType === 'professional' && (
          <ListItem button component={Link} to="/return-vouchers">
            <Tooltip title="Bon de retour" placement="right">
              <ListItemIconCustom>
                <img
                  src={retrunVoucherIcon}
                  width="25"
                  height="50"
                  alt="exchange icon"
                />
              </ListItemIconCustom>
            </Tooltip>
          </ListItem>
        )}

        <ListItem button component={Link} to="/export-commands">
          <Tooltip title="Export commandes" placement="right">
            <ListItemIconCustom>
              <img
                src={exportIcon}
                width="30"
                height="50"
                alt="export commands icon"
              />
            </ListItemIconCustom>
          </Tooltip>
        </ListItem>

        <ListItem button component={Link} to="/exports">
          <Tooltip title="Export" placement="right">
            <ListItemIconCustom>
              <img src={exportIcon} width="30" height="50" alt="export icon" />
            </ListItemIconCustom>
          </Tooltip>
        </ListItem>

        {accountType === 'professional' && isStockHandled && (
          <div>
            <ListItem
              button
              component={Link}
              to="/operations"
              style={{ paddingLeft: '10px' }}
            >
              <Tooltip title="Opérations" placement="right">
                <ListItemIconCustom>
                  <img
                    src={operationsIcon}
                    width="42"
                    height="50"
                    alt="Opération icon"
                  />
                </ListItemIconCustom>
              </Tooltip>
            </ListItem>

            <ListItem button onClick={openStockMenu}>
              <Tooltip title="Stock" placement="right">
                <ListItemIconCustom>
                  <img
                    src={stockIcon}
                    width="33"
                    height="50"
                    alt="Stock icon"
                  />
                </ListItemIconCustom>
              </Tooltip>
            </ListItem>

            <Menu
              id="simple-menu-stock"
              anchorEl={anchorElStocks}
              keepMounted
              open={Boolean(anchorElStocks)}
              onClose={handleClose}
              style={{ marginLeft: 50 }}
            >
              <MenuItem onClick={handleClose} component={Link} to="/stock">
                <ListItemIcon style={{ padding: '10px 0px' }}>
                  <img
                    src={stockIconBlack}
                    width="28"
                    height="50"
                    alt="stock"
                  />
                </ListItemIcon>
                <ListItemText primary="Stock" />
              </MenuItem>

              <MenuItem onClick={handleClose} component={Link} to="/receptions">
                <ListItemIcon style={{ padding: '10px 0px' }}>
                  <img
                    src={receptionMerchandisesIcon}
                    width="23"
                    height="30"
                    alt="stock"
                  />
                </ListItemIcon>
                <ListItemText primary="Réception de marchandises" />
              </MenuItem>
            </Menu>
          </div>
        )}

        <ListItem button onClick={handleClick}>
          <Tooltip title="Mon profil" placement="right">
            <ListItemIconCustom>
              <img src={userLogo} width="30" height="50" alt="Profile icon" />
            </ListItemIconCustom>
          </Tooltip>
        </ListItem>

        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          style={{ marginLeft: 50 }}
        >
          <MenuItem disabled>
            {`${currentUser.firstname} ${currentUser.lastname}`}
          </MenuItem>
          <MenuItem onClick={handleClose} component={Link} to="/profile">
            Mon Profil
          </MenuItem>
          <MenuItem onClick={logout} style={{ color: '#dc3545' }}>
            Déconnexion
          </MenuItem>
        </Menu>
      </div>
    </List>
  );
};

const mapStateToProps = state => ({
  isStockHandled: state.init.isStockHandled,
  currentUser: state.init.currentUser,
  accountType: state.init.currentAccountInformations.accountType
});

Navigation.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isStockHandled: PropTypes.bool.isRequired,
  currentUser: PropTypes.object.isRequired,
  accountType: PropTypes.string
};

export default connect(
  mapStateToProps,
  null
)(Navigation);
